<a [href]="currentRoute" class="mjs-skip-to-content" (click)="setFocus('#main-content')">
  Skip to main content
</a>
<header
  *ngIf="menus"
  [ngClass]="{
    'site-header': true,
    'fixed': fixedNav
  }">
  <a
    class="site-title"
    routerLink="/"
    title="Click to go to the myjobscotland home page">
    <img
      alt="myjobscotland"
      src="data:image/svg+xml;base64,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"
    >
  </a>
  <button
    aria-controls="main-menu"
    [attr.aria-expanded]="menuActive || 'false'"
    (click)="toggleMainMenu()"
    [ngClass]="{
      'toggle-menu': true,
      'active': menuActive || false
    }"
    *ngIf="isMobile">
    <span role="presentation" class="mjs-menu-toggle">
      <i></i><i></i><i></i>
    </span>
    <span class="element-invisible">
      {{ menuActive ? 'Close' : 'Open' }} main menu
    </span>
  </button>
  <button
    aria-controls="main-menu"
    [attr.aria-expanded]="menuActive || 'false'"
    class="menu-overlay"
    *ngIf="isMobile"
    [hidden]="isMobile && !menuActive"
    (click)="toggleMainMenu()">
    <span class="element-invisible">Close Main Menu</span>
  </button>
  <nav
    id="main-menu"
    class="site-nav"
    aria-label="Primary navigation"
    [ngClass]="{'open': menuActive}"
    [hidden]="!menuActive && isMobile"
  >
    <mjs-menu
      *ngIf="menus"
      [menu]="menus['primary']">
    </mjs-menu>
    <ul>
      <li class="user-toggle menu-icon">
        <button
          aria-controls="user-menu"
          [attr.aria-expanded]="userMenuActive || 'false'"
          (click)="toggleUserMenu()">
          <svg aria-hidden="true" focusable="false" width="22" height="22" fill="currentColor"
            class="svg-icon mjs-person position-absolute end-0 top-50 translate-middle-y me-2">
            <use xlink:href="/assets/icons/symbol-defs.svg#mjs-person"></use>
          </svg>
          {{ currentAuth ? (currentAuth.forename ? currentAuth.forename : 'Your Account') : 'Log in / Register' }}
        </button>
      </li>
    </ul>
  </nav>
  <button
    aria-controls="user-menu"
    [attr.aria-expanded]="userMenuActive || 'false'"
    aria-label="Open user account navigation"
    class="toggle-user-menu"
    (click)="toggleUserMenu()"
    *ngIf="isMobile">
    <span aria-hidden="true" class="mjs-user-toggle"><i></i><i></i></span>
  </button>
  <button
    class="menu-overlay"
    aria-hidden="true"
    aria-label="Close user account navigation"
    *ngIf="userMenuActive"
    (click)="toggleUserMenu()">
  </button>
  <nav
    class="user-menu"
    id="user-menu"
    [hidden]="!userMenuActive"
    aria-label="User account navigation"
    cdkTrapFocus>
    <button
      aria-controls="user-menu"
      [attr.aria-expanded]="userMenuActive || 'false'"
      aria-label="CLose user menu"
      class="toggle-user-menu btn btn-block"
      (click)="toggleUserMenu()">
      <span
        aria-hidden="true">
        <i></i><i></i>
      </span>
      Close <span class="element-invisible">user menu</span>
    </button>
    <!-- <h3 class="p-2 m-0 text-left"
      *ngIf="currentAuth && currentAuth.field_forename"
      [innerHtml]="'Hello ' + currentAuth.field_forename">
    </h3> -->
    <mjs-menu
      *ngIf="menus && currentAuth"
      [menu]="menus['user']"
      [user]="'1'"
      [recruiter]="recruiter">
    </mjs-menu>
    <mjs-login
      *ngIf="!loading && !currentAuth"
      [username]="username"
      [password]="password"
      [submit]="submit">
    </mjs-login>
    <mjs-loader *ngIf="!currentAuth && loading"></mjs-loader>
  </nav>
</header>
